import { CommonCaseTypeResponse } from '@/api/services/common/case-type/common-case-type.dto'
import { commonCaseTypeService } from '@/api/services/common/case-type/common-case-type.service'
import { initialLocalCasesTypesModalBasicFormState, LocalCasesTypesModalBasicForm, LocalCasesTypesModalBasicFormComboCaseTypesSelected } from '@/modules/configurationModule/detail/local-cases/local-case-types/components/local-case-types-modal-basic-form/local-case-types-modal-basic-form.model'
import { ConfigurationCaseTypeLaboratoryCreateRequest, ConfigurationCaseTypeLaboratoryPatchInBatchRequest, ConfigurationCaseTypeLaboratoryResponse } from '@/modules/configurationModule/detail/local-cases/local-case-types/services/local-case-types.dto'
import { Nullable } from '@/shared/types/app.types'
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class LocalCaseTypesModalBasicForm extends Vue {
    @Prop() readonly selectedRow!: ConfigurationCaseTypeLaboratoryResponse
    @Prop() readonly actionTitle!: string
    @Emit()
    updateCaseType(): ConfigurationCaseTypeLaboratoryPatchInBatchRequest {
        return {
            active: this.selectedRow.active,
            description: this.selectedRow.description,
            id: this.selectedRow.id,
            serial: this.selectedRow.serial

        }
    }
    @Emit()
    createCaseType(): ConfigurationCaseTypeLaboratoryCreateRequest {
        const selectedCaseTypeId: LocalCasesTypesModalBasicFormComboCaseTypesSelected = this.state.caseTypes.selected as LocalCasesTypesModalBasicFormComboCaseTypesSelected
        return {
            active: this.selectedRow.active,
            caseTypeId: selectedCaseTypeId.value,
            description: this.selectedRow.description,
            serial: this.selectedRow.serial
        }
    }

    state: LocalCasesTypesModalBasicForm
    constructor() {
        super()
        this.state = initialLocalCasesTypesModalBasicFormState()
    }

    get modelValidated(): boolean {
        const caseTypeSelectionExists = !!this.state.caseTypes.selected
        const caseTypeLocalNameValidated = !!this.selectedRow.description.length
        const caseTypeSerialValidated = !!this.selectedRow.serial.length
        const anyFieldIsDirty = this.$_someFieldIsDirty(this.fields)
        const hasErrors = !!this.errors.count()
        return anyFieldIsDirty && !hasErrors && caseTypeSelectionExists && caseTypeLocalNameValidated && caseTypeSerialValidated
    }

    get canEditCombo(): boolean {
        return !this.selectedRow.id
    }

    async getActiveCaseTypes(): Promise<LocalCasesTypesModalBasicFormComboCaseTypesSelected[]> {
        const [error, response] = await this.$_toCall(commonCaseTypeService.getCaseTypes())
        if (error) {
            this._setList()
            this._setSelection()
            return []
        }
        const caseTypesActive = response.filter((caseType: CommonCaseTypeResponse) => caseType.active)
        const caseTypeParsed: LocalCasesTypesModalBasicFormComboCaseTypesSelected[] = caseTypesActive.map((caseType: CommonCaseTypeResponse) => {
            return {
                value: caseType.id,
                text: caseType.description
            }
        })
        this._setList(caseTypeParsed)
        this._setSelection()
        return caseTypeParsed
    }

    update(): void {
        if (this.selectedRow.id) {
            this.updateCaseType()
        } else {
            this.createCaseType()
        }
    }

    private _setList(list: LocalCasesTypesModalBasicFormComboCaseTypesSelected[] = []): void {
        this.state.caseTypes.list = list
    }

    private _setSelected(selected: Nullable<LocalCasesTypesModalBasicFormComboCaseTypesSelected> = null): void {
        this.state.caseTypes.selected = selected
    }

    private _setSelection(): void {
        const list = this.state.caseTypes.list
        if (list?.length) {
            const foundCaseType = this.state.caseTypes.list.find(caseType => caseType.value === this.selectedRow.caseType.id)
            if (foundCaseType) {
                this._setSelected(foundCaseType)
                return
            }
        }
        this._setSelected()
    }
}
